<script>
import Layout from '@/router/layouts/main';
import appConfig from '@/app.config';
import PageHeader from '@/components/page-header';
import Commission from './Commission.vue';
import Wallet from './Wallet.vue';
/**
 * Crypto Dashboard Component
 */
export default {
  page: {
    title: 'Lịch Sử',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Commission, Wallet },
  data() {
    return {
      title: 'Lịch Sử',
      items: [
        {
          text: 'Hệ Thống',
          href: '/',
        },
        {
          text: 'Lịch Sử',
          active: true,
        },
      ],
      tabsActive: 'Wallet',
    };
  },
  created() {
    this.$store.dispatch('wallet/req_getListCoin');
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="cols-12">
        <div class="history-page">
          <b-container class="box-title" v-if="false">
            <div class="navbar-link">
              <a
                :class="{ active: tabsActive === 'Wallet' }"
                @click="tabsActive = 'Wallet'"
              >
                <div class="text">Lịch Sử Ví</div>
              </a>
            </div>
            <div class="navbar-link">
              <a
                :class="{ active: tabsActive === 'Commission' }"
                @click="tabsActive = 'Commission'"
              >
                <div class="text">Lịch Sử Hoa Hồng</div>
              </a>
            </div>
          </b-container>
          <div class="content-box">
            <component
              :is="tabsActive"
              :key="`box-profile-${tabsActive}`"
              :ref="tabsActive"
            >
            </component>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
.history-page {
  width: 100%;
  position: relative;
  margin-bottom: 1.25rem;
  .container {
    @media (min-width: 768px) {
      max-width: 700px;
    }
    @media (min-width: 1200px) {
      max-width: 1140px;
    }
    @media (min-width: 1600px) {
      max-width: 1440px;
    }
  }
  .box-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 40px;
    padding: 0 0;
    min-height: 40px;
    background-color: #556ee6;
    border-radius: 10px;
    box-shadow: 0px 7px 10px 2px #00000038;
    .navbar-link {
      width: 100%;
      max-width: 200px;
      min-width: 120px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      &:first-child {
        a {
          border-top-left-radius: 9px;
          border-bottom-left-radius: 9px;
        }
      }
      a {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        text-decoration: none;
        &.active {
          border-bottom: 3px solid #ffff;
          background: linear-gradient(89deg, #00000075, #00000070);
        }

        .text {
          color: #fff;
          font-weight: 600;
          font-size: clamp(15px, 2vw, 17px);
          text-transform: uppercase;
        }
        .icon {
          img {
            height: 20px;
            width: auto;
          }
        }
      }
    }
  }
  .content-box {
    padding: 2rem 0;
  }
}
</style>
